import dayjs, { Dayjs } from 'dayjs';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Stack } from '@mui/material';

import { PoolDatePicker } from '../../date-picker/pool-date-picker';
import { useFilter } from '../context/filter-context';

export const LegacyDateRangeFilter = () => {
    const { filter, updateFilter, registerFilterMap } = useFilter();

    // Send both bounds as a full start-of-day timestamp (the endpoint validates a
    // datetime, so a bare Y-m-d is rejected). The backend widens the "until" bound
    // to end of day (see TimestampFilterTrait). Using startOf('day') for "until"
    // too — instead of endOf('day') — avoids the picker re-rendering the next day:
    // 23:59:59 rolled over the local/UTC boundary and showed 12.06 for a picked 11.06.
    const handleChangeFrom = (value: Dayjs | null) => {
        filter.delete('createdAtFrom');
        if (value?.isValid()) {
            filter.set('createdAtFrom', value.startOf('day').format());
        }
        updateFilter(filter);
    };

    const handleChangeTo = (value: Dayjs | null) => {
        filter.delete('createdAtUntil');
        if (value?.isValid()) {
            filter.set('createdAtUntil', value.startOf('day').format());
        }
        updateFilter(filter);
    };

    const dateToString = (rfcString: unknown) =>
        (rfcString as string) && (
            <FormattedDate value={new Date(rfcString as string)} year="numeric" month="short" day="2-digit" />
        );

    registerFilterMap('createdAtFrom', dateToString);
    registerFilterMap('createdAtUntil', dateToString);

    const currentFrom = filter.get('createdAtFrom');
    const currentTo = filter.get('createdAtUntil');
    return (
        <Stack gap={1} direction="row">
            <PoolDatePicker
                label={<FormattedMessage id="app.filter.date.from" />}
                value={currentFrom ? dayjs(currentFrom) : null}
                onChange={handleChangeFrom}
            />
            <PoolDatePicker
                label={<FormattedMessage id="app.filter.date.until" />}
                value={currentTo ? dayjs(currentTo) : null}
                onChange={handleChangeTo}
            />
        </Stack>
    );
};
